import { render, staticRenderFns } from "./icons.vue?vue&type=template&id=54eab018&scoped=true"
import script from "./icons.vue?vue&type=script&lang=js"
export * from "./icons.vue?vue&type=script&lang=js"
import style0 from "./icons.vue?vue&type=style&index=0&id=54eab018&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eab018",
  null
  
)

export default component.exports